import { SupportedBrowser, supportedBrowsersVersionsList } from '../config/constants';

const check = (browser: SupportedBrowser, version: number) => {
    const minVersion = supportedBrowsersVersionsList[browser];

    return version >= minVersion;
};

export const checkBrowserVersion = (browser: string, version: number) => {
    switch (browser.toLocaleLowerCase()) {
        case 'chrome':
        case 'edge':
        case 'firefox':
        case 'safari':
        case 'yandex':
            return check(browser as SupportedBrowser, version);
        default:
            return false;
    }
};

export const getBrowserInfo = (userAgent: string) => {
    let browserInfo = { browser: 'unknown', version: 0 };

    if (/Chrome/.test(userAgent)) {
        const version = userAgent.match(/Chrome\/(\d+)/);
        browserInfo = { browser: 'Chrome', version: version ? parseInt(version[1]) : 0 };
    }

    if (/YaBrowser/.test(userAgent)) {
        const version = userAgent.match(/YaBrowser\/(\d+)/);
        browserInfo = { browser: 'Yandex', version: version ? parseInt(version[1]) : 0 };
    }

    if (/Edg/.test(userAgent)) {
        const version = userAgent.match(/Edg\/(\d+)/);
        browserInfo = { browser: 'Edge', version: version ? parseInt(version[1]) : 0 };
    }

    if (/Firefox/.test(userAgent)) {
        const version = userAgent.match(/Firefox\/(\d+)/);
        browserInfo = { browser: 'Firefox', version: version ? parseInt(version[1]) : 0 };
    }

    if (/Version\/(\d+\.\d+).*Safari/.test(userAgent)) {
        const version = userAgent.match(/Version\/(\d+).*Safari/);
        browserInfo = { browser: 'Safari', version: version ? parseInt(version[1]) : 0 };
    }

    return browserInfo;
};
